export default function CTASection() {
  return (
    <section className="relative flex flex-col lg:flex-row min-h-[480px] md:min-h-[560px]">
      <div className="relative lg:w-1/2 h-[320px] lg:h-auto overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20fashion%20warehouse%20interior%20with%20organized%20clothing%20racks%20and%20sneaker%20boxes%20on%20wooden%20shelves%20soft%20natural%20light%20streaming%20through%20large%20windows%20cream%20and%20beige%20tones%20editorial%20photography%20with%20gentle%20shadows%20clean%20aesthetic%20lifestyle%20look&width=800&height=1000&seq=cta-left-v1&orientation=portrait"
          alt="Get the CSSBuy Spreadsheet"
          className="absolute inset-0 w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-foreground-950/25"></div>
        <div className="absolute top-6 left-6">
          <span className="text-xs font-medium text-background-50/80 tracking-wider uppercase whitespace-nowrap">Limited Access</span>
        </div>
        <div className="absolute bottom-8 left-6 right-6">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
            Get The Sheet<br />Save Money<br />Buy Smarter
          </h2>
        </div>
      </div>

      <div className="lg:w-1/2 flex flex-col items-center justify-center text-center px-6 md:px-14 py-10 md:py-14 bg-background-50">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
          Ready to Order?
        </h2>
        <p className="mt-5 text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
          Stop wasting hours searching for working links and trusted sellers. Our CSSBuy spreadsheet directory gives you instant access to 3000+ verified product links, organized by brand and category. Whether you are buying your first haul or restocking favorites, everything you need is one click away on CSSBuy Sheet.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center gap-2 px-10 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
        >
          Buy It Now
          <i className="ri-arrow-right-line text-base"></i>
        </a>
      </div>
    </section>
  );
}